import { numberHelpers } from '@approvalmax/utils';
import { selectors } from 'modules/common';
import { useSelector } from 'modules/react-redux';

import { getXeroLineItems, getXeroLineItemsSummary } from '../../../selectors/xero';
import { XeroRequestItemsSummaryProps } from './XeroRequestItemsSummary.types';

export const useXeroRequestItemsSummary = (props: XeroRequestItemsSummaryProps) => {
    const { request, ocrData } = props;

    const templateName = selectors.template.getTemplateDisplayNameByCode(request.integrationCode);

    const summary = useSelector((state) => getXeroLineItemsSummary(state, request));
    const lineItems = useSelector((state) => getXeroLineItems(state, request));

    const showTotalWarning = Boolean(ocrData?.document?.total && summary.totalAmount !== ocrData.document?.total);

    const showSubtotalWarning = Boolean(
        ocrData?.document?.subTotal && summary.subtotalAmount !== ocrData.document?.subTotal
    );

    const totalTax = summary.taxInfo.reduce<number>(
        (previousValue, currentValue) => previousValue + currentValue.taxAmount,
        0
    );

    const showTaxTotalWarning =
        numberHelpers.isNumber(ocrData?.document?.totalTax) && totalTax !== ocrData.document?.totalTax;

    return {
        summary,
        totalTax,
        lineItems,
        templateName,
        showTotalWarning,
        showSubtotalWarning,
        showTaxTotalWarning,
    };
};
